"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayoutStyles = exports.useLayoutSectionStyles = exports.constants = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tss = require("../styles/tss");
var _breakpoints = require("../system/breakpoints");
var _style = require("../system/style");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const selectors = {
  allChildren: '& > *',
  allChildrenExceptLast: '& > *:not(:last-child)',
  notFirstOfType: '&:not(:first-of-type)',
  notLastOfType: '&:not(:last-of-type)',
  allSections: '& .layoutSection'
};
const constants = exports.constants = {
  maxWidth: '80em',
  outerSpacing: {
    upXs: 2,
    up360: 3,
    up480: '5%',
    upMd: '6.25%'
  }
};

/**
 * Style rules for the Layout component
 */
const useLayoutStyles = exports.useLayoutStyles = (0, _tss.makeTssStyles)({
  name: 'DsLayout',
  uniqId: 'gB78g2'
})((theme, props) => {
  const {
    breakpoints
  } = theme.busbud;
  return {
    root: {
      backgroundColor: getColorFromKey(theme, props.bgColor),
      maxWidth: '100%'
    },
    withColumns: {
      flexDirection: 'column',
      [breakpoints.up('xl')]: {
        flexDirection: 'row',
        boxSizing: 'border-box',
        [selectors.allChildrenExceptLast]: {
          marginRight: gridToPct(props.columnSpacing)
        }
      }
    },
    responsiveVerticalMargin: _objectSpread({}, getResponsiveVerticalSpacing(theme, 'margin', props.yMargin)),
    responsiveGap: _objectSpread({}, getResponsiveVerticalGap(theme, props.gap)),
    outerSpacing: _objectSpread({}, getOuterSpacingRules(theme, props.gutters, props.withColumns))
  };
});

/**
 * Style rules for the LayoutSection component
 */
const useLayoutSectionStyles = exports.useLayoutSectionStyles = (0, _tss.makeTssStyles)({
  name: 'DsLayoutSection',
  uniqId: 'OOwazT'
})((theme, props) => {
  const {
    styles,
    breakpoints,
    colors,
    spacing
  } = theme.busbud;
  const defaultValue = {
    xs: 4,
    sm: 6,
    xl: 0
  };
  const value = props.yMargin === true ? defaultValue : props.yMargin;
  return {
    root: {
      backgroundColor: getColorFromKey(theme, props.bgColor)
    },
    contentWrapper: {
      [breakpoints.up('xl')]: {
        maxWidth: constants.maxWidth,
        paddingLeft: computeGutterPadding(props.gutters),
        paddingRight: computeGutterPadding(props.gutters),
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    },
    containedVariant: {
      paddingTop: spacing(4),
      paddingBottom: spacing(4),
      [breakpoints.up('sm')]: {
        paddingTop: spacing(6),
        paddingBottom: spacing(6)
      },
      [breakpoints.up('xl')]: {
        padding: spacing(6, gridToPct(1.25)),
        backgroundColor: !props.bgColor ? colors.background.secondary.opaque : undefined,
        borderRadius: !props.fullWidth ? styles.rounding.xl : undefined
      }
    },
    floatingVariant: {},
    responsiveStickyPosition: getResponsiveStickyPosition(theme, props.sticky),
    responsiveVerticalMargin: getResponsiveVerticalSpacing(theme, 'margin', value),
    responsiveVerticalPadding: getResponsiveVerticalSpacing(theme, 'padding', props.yPadding),
    alternatingBackground: getAlternatingBackgroundRules(theme, props.fullWidth)
  };
});
function getResponsiveStickyPosition(theme, stickyProp) {
  if (!stickyProp) return {};
  const {
    spacing
  } = theme.busbud;

  // @ts-ignore We need to fix `handleBreakpoints` typings
  return (0, _breakpoints.handleBreakpoints)(theme, stickyProp, value => {
    if (!value) return undefined;
    return {
      position: 'sticky',
      top: spacing(6),
      bottom: 0
    };
  });
}
function getOuterSpacingRules(theme, gutters, isColumnLayout) {
  const {
    breakpoints,
    spacing
  } = theme.busbud;
  const {
    outerSpacing,
    maxWidth
  } = constants;
  function withGutters(value) {
    if (!gutters) return value;
    // We need to scale the gutters value to the available space after applied padding
    const horizontalPadding = 2 * parseInt(outerSpacing.upMd) / 100;
    return `calc(${gridToPct(gutters * 1 - horizontalPadding)} + ${value})`;
  }
  const sectionSpacingRules = {
    paddingLeft: spacing(outerSpacing.upXs),
    paddingRight: spacing(outerSpacing.upXs),
    [breakpoints.up(360)]: {
      paddingLeft: spacing(outerSpacing.up360),
      paddingRight: spacing(outerSpacing.up360)
    },
    [breakpoints.up(480)]: {
      paddingLeft: spacing(outerSpacing.up480),
      paddingRight: spacing(outerSpacing.up480)
    },
    [breakpoints.up('md')]: {
      paddingLeft: spacing(outerSpacing.upMd),
      paddingRight: spacing(outerSpacing.upMd)
    },
    [breakpoints.up('xl')]: {
      // Apply gutters to content wrapper
      '& > *': {
        paddingLeft: computeGutterPadding(gutters),
        paddingRight: computeGutterPadding(gutters)
      }
    }
  };
  if (!isColumnLayout) {
    return {
      // On single-column layouts, the outer spacing is applied on the sections
      [selectors.allSections]: sectionSpacingRules
    };
  }
  return {
    [breakpoints.down('lg')]: {
      // On LG-down, the outer spacing is always defined on the sections, because each section background
      // fills the whole width while its content respects the padding.
      [selectors.allSections]: sectionSpacingRules
    },
    [breakpoints.up('xl')]: {
      // Outer padding + gutters
      paddingLeft: withGutters(spacing(outerSpacing.upMd)),
      paddingRight: withGutters(spacing(outerSpacing.upMd)),
      // To properly set the layout maxWidth, we use content-box and subtract the gutters from the constant value
      // e.g. for a gutter value of 1, the maxWidth will be calc(80em * 22/24)
      boxSizing: 'content-box',
      width: 'unset',
      // width is set to 100% by Grid but it doesn't work well with content-box
      maxWidth: `calc(${maxWidth} * ${gridToRatio(24 - 2 * (gutters || 0))})`,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  };
}
function getResponsiveVerticalSpacing(theme, spacingProp, spacingValue) {
  if (spacingValue === undefined) return {};
  return (0, _breakpoints.handleBreakpoints)(theme, spacingValue, value => {
    // We need this intermediary assignment to have proper typing
    const spacingRules = {
      [selectors.notFirstOfType]: {
        [`${spacingProp}Top`]: theme.busbud.spacing(value)
      },
      [selectors.notLastOfType]: {
        [`${spacingProp}Bottom`]: theme.busbud.spacing(value)
      }
    };
    return spacingRules;
  });
}
function getResponsiveVerticalGap(theme, gapProp) {
  if (!gapProp) return {};
  return (0, _breakpoints.handleBreakpoints)(theme, gapProp, value => ({
    '& .layoutSection:not(:last-child)': {
      marginBottom: theme.busbud.spacing(value)
    }
  }));
}
function getAlternatingBackgroundRules(theme, isAlwaysFullWidth) {
  const {
    breakpoints,
    colors
  } = theme.busbud;
  return {
    [isAlwaysFullWidth ? '&' : breakpoints.down('lg')]: {
      '&:nth-of-type(2n)': {
        backgroundColor: colors.background.secondary.opaque
      }
    }
  };
}
function computeGutterPadding(gutters) {
  const {
    maxWidth
  } = constants;
  if (!gutters) return undefined;
  return `min(${gridToRatio(gutters)} * ${maxWidth},${gridToPct(gutters)})`;
}

/**
 * Returns a color value based on the theme color key.
 * TODO: to be moved to a more generic location within the DSCL
 *
 * @param theme The theme object.
 * @param colorKey The color key. Example: "background.primary.opaque"
 */
function getColorFromKey(theme, colorKey) {
  if (!colorKey) return colorKey;
  // TODO: Replace with `getColorValue()` function when it'll be added
  // https://github.com/busbud/design-system/issues/1267
  return (0, _style.getPath)(theme, `busbud.colors.${colorKey}`) || undefined;
}

/**
 * Converts a number in a 24-columns grid scale to a percentage value
 * TODO: to be moved to a more generic location within the DSCL
 *
 * @param value A number between 0 and 24
 */
function gridToPct(value) {
  return value ? `${value / 24 * 100}%` : 0;
}

/**
 * Converts a number in a 24-columns grid scale to a ratio between 0 and 1
 * TODO: to be moved to a more generic location within the DSCL
 *
 * @param value A number between 0 and 24
 */
function gridToRatio(value) {
  return value ? value / 24 : 0;
}